<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import Icon from 'next/icon/Icon.vue';
import { useMessageContext } from '../provider.js';

const { attachments } = useMessageContext();

const title = computed(() => {
  const attachment = attachments.value[0];
  return attachment?.fallbackTitle ?? attachment?.fallback_title ?? '';
});
</script>

<template>
  <BaseBubble class="px-4 py-3" data-bubble-name="fallback">
    <div class="flex items-center gap-2 text-sm text-n-slate-11">
      <Icon icon="i-ph-warning-circle" class="size-4 shrink-0" />
      <span>{{ title || $t('CONVERSATION.MEDIA_NOT_AVAILABLE') }}</span>
    </div>
  </BaseBubble>
</template>
